export const BASE_TARGET_COLUMNS = [
	{ value: 'select', label: 'Select' },
	{ value: 'id', label: 'ID' },
	{ value: 'title', label: 'Title' },
	{ value: 'entity_type', label: 'Entity Type' },
	{ value: 'description', label: 'Description' },
	{ value: 'definition', label: 'Definition' },
	{ value: 'sql', label: 'SQL' },
	{ value: 'pii', label: 'PII' },
	{ value: 'verified', label: 'Verified' },
	{ value: 'published', label: 'Published' },
	{ value: 'collections', label: 'Collections' },
	{ value: 'owners', label: 'Owners' },
	{ value: 'tags', label: 'Tags' },
	{ value: 'teams', label: 'Teams' },
	{ value: 'synonyms', label: 'Synonyms' },
];
